module.exports = __webpack_public_path__ + "img/clogo.ed6d6f01.png";